import "./ResultComponent.css";
import moment from "moment";
import React, { PureComponent } from "react";
import axios from "axios";
import { endpointURL } from "../../values";

class ResultComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  downloadCert = async () => {
    let targetEndpoint = "";
    let parent = this;
    let isFEM = false;
    switch (this.props.cert.cert_type) {
      case 0:
        targetEndpoint = endpointURL + "/download-ga1";
        break;
      case 1:
        targetEndpoint = endpointURL + "/download-ga1-la";
        break;
      case 2:
        targetEndpoint = endpointURL + "/download-ga3";
        break;
      case 3:
        targetEndpoint = endpointURL + "/download-qbtr";
        break;
      case 4:
        targetEndpoint = endpointURL + "/download-fem";
        isFEM = true;
        break;
    }
    console.log(this.props.cert);
    if (isFEM) {
      let { data: mainUrl } = await axios.post(targetEndpoint, {
        headers: {
          Authorization: "JWT " + "TOKEN",
        },
        data: {
          cert: this.props.cert,
          downloadType: "main",
        },
      });

      let { data: listUrl } = await axios.post(targetEndpoint, {
        headers: {
          Authorization: "JWT " + "TOKEN",
        },
        data: {
          cert: this.props.cert,
          downloadType: "list",
        },
      });

      window.open(endpointURL + mainUrl, "_blank");
      window.open(endpointURL + listUrl, "_blank");
    } else {
      axios
        .post(targetEndpoint, {
          headers: {
            Authorization: "JWT " + "TOKEN",
          },
          data: {
            //cert data will go here
            cert: this.props.cert,
          },
        })
        .then(function (res) {
          let url = res.data;
          console.log("RESULT: " + JSON.stringify(res.data));
          window.open(endpointURL + url, "_blank");
          //Returns a URL of the new file
          //HERE we open that url in a new tab
        });
    }
  };

  render() {
    let props = this.props;
    let certType = "GA1 Cert";
    switch (props.cert.cert_type) {
      case 0:
        certType = "GA1 Cert";
        break;
      case 1:
        certType = "GA1 Lifting Accessories";
        break;
      case 2:
        certType = "GA1 Fall Arrest";
        break;
      case 3:
        certType = "Quarry Brake Test Report";
        break;
      case 4:
        certType = "Fire Ext. Cert";
        break;
    }
    let examDateObj = moment(props.cert.exam_date);
    let examDate = examDateObj.format("DD/MM/YYYY");
    let renewalDateObj = moment(props.cert.renewal_date);
    let renewalDate = renewalDateObj.format("DD/MM/YYYY");
    return (
      <div className="result__main">
        <div className="result__type">{certType}</div>
        <div className="result__name">{props.cert.custom_name}</div>
        <div className="result__renewal">{props.cert.serial_number}</div>

        <div className="result__date">{examDate}</div>
        <div className="result__renewal">{renewalDate}</div>
        <div className="result__button" onClick={() => this.downloadCert()}>
          Download
        </div>
      </div>
    );
  }
}

export default ResultComponent;
